var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{attrs:{"cols":"12","sm":"6","md":"6"}},[_c('v-text-field',{attrs:{"label":"Ehliyet No","outlined":"","dense":""},on:{"input":_vm.input},model:{value:(_vm.localValue.ehliyet_no),callback:function ($$v) {_vm.$set(_vm.localValue, "ehliyet_no", $$v)},expression:"localValue.ehliyet_no"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }